import { ReactComponent as AddChartIcon } from './add_chart.svg';

export default AddChartIcon;
